import { render, staticRenderFns } from "./RequestOrderProveedor.vue?vue&type=template&id=567894b4&scoped=true&"
import script from "./RequestOrderProveedor.vue?vue&type=script&lang=js&"
export * from "./RequestOrderProveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567894b4",
  null
  
)

export default component.exports